import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BehaviorSubjectService } from 'src/app/utility-packages/is-logged-in/behaviorSubject.service';
import { AnnouncementsEntityService } from '../home-announcements/ngrx/announcements-entity.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private announcementsEntityService: AnnouncementsEntityService,
    public behaviourSubjectService: BehaviorSubjectService
  ){}

  ngOnInit(): void {
    this.announcementsEntityService.getAll();
  }

}
